import React, { useState, useEffect, useContext } from "react";
import { getFieldNames } from "../../../service/UserDashboard";
import AppContext from "../../../context/AppContext";
import translations from "../../common/Translations";
import CommonButton from "../../common/CommonButton";
import ReactSelector from "../../common/CommonReactSelector";
import { components } from "react-select";
import ModalCloseButton from "../../common/ModalCloseButton";

const Placeholder = (props) => <components.Placeholder {...props} />;

const ActivityQuestions = ({
  onClose,
  handleOpenListModal,
  dashboardNameInput,
  selectedFieldQuestionId,
  handleQuestionChange,
}) => {
  const [fieldQuestion, setFieldQuestion] = useState([]);
  const { theme, langMode } = useContext(AppContext);

  useEffect(() => {
    const fetchFieldNames = async () => {
      const fieldNames = await getFieldNames(dashboardNameInput);
      setFieldQuestion(fieldNames);
    };
    fetchFieldNames();
  }, [dashboardNameInput]);

  const questionOptions = (fieldQuestion || []).map((que) => ({
    value: String(que.workflowFormFieldId),
    label: que.fieldName,
  }));

  const panelClass =
    theme === "dark"
      ? "dark-mode border border-gray-600 bg-gray-800"
      : theme === "high-contrast"
        ? "high-contrast"
        : "bg-white";

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black/50 z-50 backdrop-blur-sm p-4">
      <div className={`relative w-full max-w-md rounded-xl shadow-xl ${panelClass}`}>
        <div className="p-6">
          <div className="mb-4 flex items-center justify-between gap-3">
            <h5 className="font-semibold text-lg">
              {translations[langMode].ActivityQuestions}
            </h5>
            <ModalCloseButton onClick={onClose} ariaLabel="Close" />
          </div>

          <div className="flex flex-col gap-2">
            <label
              htmlFor="fieldQuestion"
              className="text-sm font-medium text-gray-900 dark:text-white"
            >
              {translations[langMode].FieldQuestion}
            </label>
            <ReactSelector
              id="fieldQuestion"
              options={questionOptions}
              value={
                questionOptions.find(
                  (o) => o.value === String(selectedFieldQuestionId)
                ) || null
              }
              onChange={(opt) =>
                handleQuestionChange({
                  target: { value: opt?.value || "" },
                })
              }
              components={Placeholder}
              placeholder={translations[langMode].Select}
              height="46px"
              isClearable={false}
              menuPortalTarget={document.body}
            />
          </div>

          <div className="flex justify-end items-center mt-6 gap-3">
            <CommonButton colorIntent="danger"
              type="button"
              onClick={onClose}
              variant="danger"
              tooltipText={translations[langMode].cancelandclose}
              tooltipPosition="top"
            >
              {translations[langMode].cancle}
            </CommonButton>
            <CommonButton colorIntent="primary"
              type="button"
              variant="primary"
              tooltipText={translations[langMode].processthenextstep}
              tooltipPosition="left"
              onClick={handleOpenListModal}
            >
              {translations[langMode].next}
            </CommonButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityQuestions;
